import guestGuard from '@/router/guards/guest-guard'
import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'
import Login from '@/views/auth/Login.vue'
import marketingGuard from '@/router/guards/marketing-guard'

export default [
  {
    path: '/auth',
    component: LayoutFull,
    redirect: '/login',
    beforeEnter: multiGuard([checkTokenGuard, guestGuard, marketingGuard]),
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { redirectIfLoggedIn: true, layout: 'full' },
        component: Login,
      },
      {
        path: 'register',
        name: 'register',
        meta: { redirectIfLoggedIn: true, layout: 'full' },
        component: () => import(/* webpackChunkName: "register" */ '@/views/auth/Register.vue'),
      },
      {
        path: 'forget-password',
        name: 'auth:forget',
        meta: { redirectIfLoggedIn: false, layout: 'full' },
        component: () => import(/* webpackChunkName: "register" */ '@/views/auth/forget-pass.vue'),
      },
    ],
  },
  {
    path: '/email-verified',
    name: 'email-verified',
    meta: { layout: 'full' },
    component: () => import(/* webpackChunkName: "register" */ '@/views/auth/EmailVerifiedView.vue'),
  },
]
